import axios from "axios";
import envService from "@/services/env.service";
import userService from "@/services/user.service";

const BASE_URL = envService.getApiBaseUrl() + '/sms/prefix';

export default {
    getAllAllowedPrefixes(webId) {
        return axios.get(BASE_URL + '/' + webId + '/allow');
    },

    getPrefixesByDestinationGroup(webId, destinationGroupName) {
        return axios.get(BASE_URL + '/' + webId + '/allow/'+ destinationGroupName);
    },

    updatePrefixes(webId, prefix) {
        return axios.put(BASE_URL + '/' + webId + '/allow',
            {
                "prefixes": prefix
            }, {
                headers: {
                    'X-User-Email': userService.getLoggedInUser().email,
                }
            })
    },
}